import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUtmParametersResponse } from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';
import {
  ILeadSource,
  ITriggerSelectBoxOption,
} from '../../interfaces/shared.trigger-service.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedTriggerService {
  constructor(private readonly _httpService: HttpService) {}

  public getFormSelectBox(): Observable<ITriggerSelectBoxOption[]> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.v1TriggerQuestionnaire;
    return this._httpService.get<ITriggerSelectBoxOption[]>(apiUrl);
  }

  public getTriggerQuestions(
    source: string,
    sourceId?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (source && source.trim()) {
      params = params.set('source', source);
    }

    if (sourceId) {
      params = params.set('sourceId', sourceId);
    }

    return this._httpService.get<any>(
      API_ENDPOINTS.TRIGGER_ENDPOINTS.getQuestions,
      {
        params,
        attachTenantId: true,
      }
    );
  }

  public getReviewFormData(): Observable<ITriggerSelectBoxOption[]> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.v1TriggerReview;
    return this._httpService.get<ITriggerSelectBoxOption[]>(apiUrl);
  }

  public getLandingPageSelectBox(): Observable<ITriggerSelectBoxOption[]> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.v1LandingPage;
    return this._httpService.get<ITriggerSelectBoxOption[]>(apiUrl);
  }

  public getLeadSourceForCampaign(): Observable<ILeadSource[]> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.leadSourceList;
    return this._httpService.get<ILeadSource[]>(apiUrl);
  }

  public getLeadSource(
    sources?: string[],
    landingPages?: string[],
    forms?: string[]
  ): Observable<string[]> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.leadSourceUrlsList(
      sources,
      landingPages,
      forms
    );
    return this._httpService.get<string[]>(apiUrl);
  }

  /**
   * Fetches distinct UTM parameters for filters
   * @returns An observable containing UTM parameters (sources, mediums, campaigns, terms, contents)
   */
  public getUtmParameters(): Observable<IUtmParametersResponse> {
    const apiUrl = API_ENDPOINTS.CONTACTS_ENDPOINTS.getUtmParameters;
    return this._httpService.get<IUtmParametersResponse>(apiUrl);
  }

  public addSourceUrl(sourceUrl: string): Observable<string> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.addLeadSourceUrl;

    const payload = {
      sourceUrl: sourceUrl,
    };

    return this._httpService.post<string, { sourceUrl: string }>(
      apiUrl,
      payload
    );
  }
}
